'use strict';

var fragt = fragt || {};

fragt.fileUpload = fragt.fileUpload || new function () {

    this.init = function () {
        var inputs = document.querySelectorAll( '.input--file' );
    
        Array.prototype.forEach.call( inputs, function( input )
        {
            var label = input.nextElementSibling,
                labelVal = label.innerHTML;
    
            input.addEventListener( 'change', function( e )
            {
                var fileName = '';
                if ( this.files && this.files.length > 1 ) {
                    fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
                } else {
                    fileName = e.target.value.split( "\\" ).pop();
                }
    
                if ( fileName ) {
                    label.querySelector( 'span' ).innerHTML = fileName;
                    this.parentNode.classList.add("has-file");
                } else {
                    label.innerHTML = labelVal;
                    this.parentNode.classList.remove("has-file");
                }
            });
        });
    };
}
;
